// Field configuration for Delivery Method form
import { FieldConfig, FieldRules, FieldRulesConfig } from '@/types/form'

export interface DeliveryMethodFormState {
  key: string
  name: string
  type: 'courier' | 'manual'
  charge: number
  credential_type: 'sandbox' | 'live'
  status: 'active' | 'inactive'
  description: string
  estimated_time: string
  credentials: Record<string, string>
}

export const deliveryMethodFields: (keyof DeliveryMethodFormState)[] = [
  'key',
  'name',
  'type',
  'charge',
  'credential_type',
  'status',
  'description',
  'estimated_time',
]

interface DeliveryMethodFieldsConfig extends FieldConfig<{
  key: FieldRules<DeliveryMethodFormState['key']>
  name: FieldRules<DeliveryMethodFormState['name']>
  type: FieldRules<DeliveryMethodFormState['type']>
  charge: FieldRules<DeliveryMethodFormState['charge']>
  credential_type: FieldRules<DeliveryMethodFormState['credential_type']>
  status: FieldRules<DeliveryMethodFormState['status']>
  description: FieldRules<DeliveryMethodFormState['description']>
  estimated_time: FieldRules<DeliveryMethodFormState['estimated_time']>
}> {}

interface DeliveryMethodFieldsConfigProps extends FieldRulesConfig<DeliveryMethodFormState> {}

export function deliveryMethodFieldsConfig(
  _props: DeliveryMethodFieldsConfigProps
): DeliveryMethodFieldsConfig {
  return {
    fields: {
      key: {
        rules: {
          required: 'Unique key is required',
        },
      },
      name: {
        rules: {
          required: 'Method name is required',
        },
      },
      type: {
        rules: {
          required: 'Type is required',
        },
      },
      charge: {
        rules: {
          required: 'Delivery charge is required',
        },
        min: 0,
      },
      credential_type: {
        rules: {
          required: 'Credential type is required',
        },
      },
      status: {
        rules: {
          required: 'Status is required',
        },
      },
      description: {
        rules: {},
      },
      estimated_time: {
        rules: {},
      },
    },
  }
}
